import { Grid, Icon, Typography } from '@frontierag/frontier-ui-library';
import { t } from 'i18next';

import { styles } from './styles';
import type { IEmptyState } from './types';

const EmptyState = ({ title = t('label.noRecordsFound'), icon }: IEmptyState) => {
  return (
    <Grid container justifyContent="center" sx={styles} data-testid="empty-state">
      {icon && (
        <Grid item xs={12} display="flex" justifyContent="center">
          <Icon>{icon}</Icon>
        </Grid>
      )}

      <Grid item xs={6} display="flex" justifyContent="center" py={2}>
        <Typography variant="subtitle3">{title}</Typography>
      </Grid>
    </Grid>
  );
};

export default EmptyState;
